<template>
    <h3>Staff Layout</h3>
</template>

<script>
export default {
    name: 'StaffLayout'
}
</script>